import { defineStore } from "pinia";
import { useBookingStore } from "./BookingStore";

export const useFilterStore = defineStore("filterData", {
  state: () => ({
    results: [], // the returned array of clinics found.
    filteredResults: [],
    sortby: "distance",
    priceRange: [20, 80],
    clinicianPreference: [],
    languages: [],
    parking: [],
    isInitialFilterApplied: false, // Track if initial filter has been applied after price calculation
    skipPriceFilter: false, // Flag to skip price filter on initial load
  }),

  actions: {
    setSortby(value) {
      this.sortby = value;
    },

    setResults(results) {
      this.results = results;
      this.filteredResults = results;
      this.isInitialFilterApplied = false; // Reset flag when new results are loaded
    },

    sortResults() {
      const sorted = [...this.filteredResults];

      if (this.sortby === "distance") {
        // Sort by distance in ascending order
        sorted.sort((a, b) => a.distance - b.distance);
      } else if (this.sortby === "price-lowest") {
        // Sort by totalPrice in ascending order
        sorted.sort((a, b) => a.totalPrice - b.totalPrice);
      } else if (this.sortby === "price-highest") {
        // Sort by totalPrice in descending order
        sorted.sort((a, b) => b.totalPrice - a.totalPrice);
      }

      this.filteredResults = sorted;
    },

    applyFilter() {
      // Start filtering from the complete results set
      this.filteredResults = [...this.results];

      this.filterByPrice();
      this.filterByClinician();
      this.filterByParking();
      this.filterByLanguage();
      this.sortResults(); // this should go last.

      // Mark that initial filter has been applied
      this.isInitialFilterApplied = true;
    },

    filterByPrice() {
      // Only apply price filter for vaccinations (where user has control over price range)
      const bookingStore = useBookingStore();
      if (bookingStore.serviceType !== "vaccinations") return;

      // Skip price filtering if flag is set (on initial load)
      if (this.skipPriceFilter) {
        return;
      }

      const [minPrice, maxPrice] = this.priceRange;
      this.filteredResults = this.filteredResults.filter(
        (clinic) => clinic.finalPrice >= minPrice && clinic.finalPrice <= maxPrice
      );
    },

    filterByClinician() {
      if (this.clinicianPreference.length === 0) return;

      this.filteredResults = this.filteredResults.filter((clinic) => {
        if (
          this.clinicianPreference.includes("male") &&
          clinic.has_male === "1"
        )
          return true;
        if (
          this.clinicianPreference.includes("female") &&
          clinic.has_female === "1"
        )
          return true;

        return false;
      });
    },

    filterByParking() {
      if (this.parking.length === 0) return;

      this.filteredResults = this.filteredResults.filter((clinic) => {
        for (const parkingType of this.parking) {
          if (clinic[parkingType] === "1") {
            return true;
          }
        }
        return false;
      });
    },
    filterByLanguage() {
      if (this.languages.length === 0) return;
      this.filteredResults = this.filteredResults.filter((clinic) => {
        const spokenLanguages = clinic.spoken_languages.split(",");
        return spokenLanguages.includes(this.languages);
      });
    },
  },
});
